import React, { useState } from "react";
import { BootstrapModal } from "../../BootstrapModal/Modal";
import Button from "../../Button/Button";
import { CgClose } from "react-icons/cg";
import { InputField1 } from "../../InputField1/InputField1";
import { TextArea } from "../../TextArea/TextArea";
import Typogaphy from "../../Typography/Typography";
import { useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { useDeleteUserFile } from "../../../hooks/useCrm";
export const DeleteModal = ({ show, handleClose }) => {
  const [button, setButton] = useState(false);
  const { id } = useParams();

  const { mutateAsync: DeleteUserFile, isLoading: DeletingUserFile } =
    useDeleteUserFile();
  const initialValues = {
    CauseDeleteFile: "",
    IdS0alesOpportunities: id,
  };
  const OnSubmit = async (values) => {
    await DeleteUserFile(values);
  };

  return (
    <BootstrapModal
      modaltitle="حذف کاربر"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="w-100">
        <Typogaphy size="14px">آیا از حذف این کاربر مطمئن هستید؟</Typogaphy>
        <Formik initialValues={initialValues} onSubmit={OnSubmit}>
          <Form>
            <TextArea
              className="form-control"
              placeholder="دلیل حذف خود را اینجا بنویسید"
              name={"CauseDeleteFile"}
              id={"deleteuserfile"}
              type={"textarea"}
            />
            <div className="d-flex flex-row-reverse">
              <div className="w-25 d-flex">
                <Button
                  color="#fff"
                  style={{
                    padding: "4px .5rem",
                    border: "none",
                    marginLeft: "10px",
                  }}
                  bgColor="#009ef7"
                  type="submit"
                  onclick={handleClose}
                >
                  بله
                </Button>
                <Button
                  color="#fff"
                  style={{ padding: "4px .5rem", border: "none" }}
                  bgColor="#f1416c"
                  onclick={handleClose}
                >
                  خیر
                </Button>
              </div>
            </div>
          </Form>
        </Formik>
      </div>
    </BootstrapModal>
  );
};
